import React from 'react';
import ADataGrid from "views/pages/manage/common/data-grid/EnhanceDataGrid";
import { gridStyles } from "views/pages/manage/edpOps/issuanceIDcard/printIdCardAndMapRfid/constant";
import ALoader from 'views/pages/manage/common/a-loader';
import { AGridColDef } from 'views/pages/manage/common/data-grid/ADataGridColDef';
import { Dialog, Tooltip } from '@mui/material';
import { ReactComponent as CloseIcon } from "assets/img/svg/CrossIcon.svg"
import { getStatusDescription, statusMapping, statusStyle } from './constant';
import moment from 'moment';
const BulkAuditLogs = (
    {
        rows,
        currentPage,
        currentPageSize,
        totalRecords,
        handleBulkClose,
        bulkAuditHandler,
        loader,
        isOpen
    }
) => {

    const columns = [
        new AGridColDef("fileName", "File Name", false)
            .setMinWidth(120)
            .editable(true)
            .setFlex(1.5)
            .renderCellComponent((params) => (
                params?.value ?
                    <Tooltip title={params?.value}>
                        <div className={`ellipsis-text-container`}>{params?.value}</div>
                    </Tooltip>
                    : <div>-</div>
            )),
        new AGridColDef("status", "Status", false)
            .setMinWidth(50)
            .editable(true)
            .setFlex(0.5)
            .renderCellComponent((params) => (
                params?.value ?
                    <Tooltip title={statusMapping?.[params?.value] ?? params?.value}>
                        <div className={`ellipsis-text-container`} style={statusStyle?.[params?.value]}>{statusMapping?.[params?.value] ?? params?.value}</div>
                    </Tooltip>
                    : <div>-</div>
            )),
        new AGridColDef("uploadedBy", "Uploaded by", false)
            .setMinWidth(80)
            .editable(true)
            .setFlex(0.8)
            .renderCellComponent((params) => (
                params?.value ? <Tooltip title={params?.value}>
                    <div className={`ellipsis-text-container cursor`}>
                        {params.value}
                    </div>
                </Tooltip> : <div>-</div>
            )),
        new AGridColDef("updatedOn", " Date & Time", false)
            .setMinWidth(80)
            .editable(true)
            .setFlex(0.8)
            .renderCellComponent((params) => (
                params?.value ?
                    <Tooltip title={moment(params?.value).format('YYYY-MM-DD hh:mm A')}>
                        <div className={`ellipsis-text-container`}>{moment(params?.value).format('YYYY-MM-DD hh:mm A')}</div>
                    </Tooltip>
                    : <div>-</div>
            )),

        new AGridColDef("response", "Details", false)
            .setMinWidth(150)
            .editable(true)
            .setFlex(1.5)
            .renderCellComponent((params) => (
                params?.value ?
                    <Tooltip title={getStatusDescription(params?.row?.status, params?.value) ?? params?.value}>
                        <div className={`ellipsis-text-container`}>{getStatusDescription(params?.row?.status, params?.value) ?? params?.value}</div>
                    </Tooltip>
                    : <div>-</div>
            )),

    ]
    const onChangeHandler = ({ page, pageSize }) => {
        bulkAuditHandler({ page, pageSize })
    }

    return (
        <Dialog
            open={isOpen}
            fullWidth
            maxWidth="lg"
        >
            {loader && <ALoader position="fixed" />}
            <div className='p-3'>
                <div className='d-flex justify-content-between mb-1'>
                    <div className='large-text'>Upload Logs</div>
                    <CloseIcon onClick={handleBulkClose} />
                </div>

                <div className='mt-24 mx-0 mb-4' style={{ borderBottom: " 1px solid #E2E2E2" }}></div>
                <ADataGrid
                    removeWrapperContainer
                    rows={rows || []}
                    columns={columns}
                    rowId={(row) => row.id}
                    rowHeight={50}
                    loading={loader}
                    rowCount={totalRecords}
                    currentPage={currentPage}
                    sx={gridStyles}
                    // hidePagination
                    autoHeight
                    serverPagination={false}
                    paginationModel={{ page: currentPage, pageSize: currentPageSize }}
                    nextButtonHandler={onChangeHandler}

                />

            </div>
        </Dialog>
    )
}

export default BulkAuditLogs